export const transform = (formData, tenantData = {}) => {
  return {
    ...formData,
    meta: {
      tenant: tenantData,
      generatedAt: new Date().toISOString()
    }
  };
};

export default transform;
